import { styled } from '@mui/material';

export const StyledActionsMenu = styled('div')(({ theme }) => ({
  gap: theme.spacing(5),
  display: 'flex',
  alignItems: 'center'
}));
